import { HttpContext } from '@angular/common/http';
import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { Store } from '@ngrx/store';
import { catchError, map, of } from 'rxjs';
import { environment } from '../../environments/environment';
import { UsersService } from '../_generated';
import { AuthActions } from '../store/actionstypes/auth/auth.actiontype';
import { AuthState, authFeature } from '../store/reducers/auth.reducer';
import { IS_AUTH_INTERCEPTOR_ENABLED } from './auth.interceptor';

/**
 * This is a guard that checks if the user is authenticated
 * and make sure that the user is redirected to the login page.
 */
export const authGuard: CanActivateFn = () => {
  const userService = inject(UsersService);
  const authStore = inject<Store<AuthState>>(Store);
  const user = authStore.selectSignal(authFeature.selectUser);

  return user() !== null
    ? true
    : userService
        .usersControllerGetMe(undefined, undefined, {
          context: new HttpContext().set(IS_AUTH_INTERCEPTOR_ENABLED, false),
        })
        .pipe(
          map((user) => {
            authStore.dispatch(AuthActions.authenticateUserSuccess({ user }));
            return true;
          }),
          catchError((error: Error) => {
            console.log('authGuard catchError', error);
            window.location.href = `${environment.appUiUrl}/login`;
            return of(false);
          }),
        );
};
